<template>
  <div class="login-container">
    <el-card class="login-card">
      <div slot="header" class="card-header">
        <h2>Cloud Service 云服务系统</h2>
      </div>
      
      <el-tabs v-model="activeTab">
        <!-- 登录表单 -->
        <el-tab-pane label="登录" name="login">
          <el-form :model="loginForm" :rules="loginRules" ref="loginForm" @submit.native.prevent="handleLogin">
            <el-form-item prop="email">
              <el-input
                v-model="loginForm.email"
                placeholder="邮箱"
                prefix-icon="el-icon-user"
              ></el-input>
            </el-form-item>
            
            <el-form-item prop="password">
              <el-input
                v-model="loginForm.password"
                type="password"
                placeholder="密码"
                prefix-icon="el-icon-lock"
                @keyup.enter.native="handleLogin"
              ></el-input>
            </el-form-item>
            
            <el-form-item>
              <el-button
                type="primary"
                :loading="loading"
                @click="handleLogin"
                style="width: 100%"
              >
                登录
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        
        <!-- 注册表单 -->
        <el-tab-pane label="注册" name="register">
          <el-form :model="registerForm" :rules="registerRules" ref="registerForm" @submit.native.prevent="handleRegister">
            <el-form-item prop="name">
              <el-input
                v-model="registerForm.name"
                placeholder="用户名"
                prefix-icon="el-icon-user"
              ></el-input>
            </el-form-item>
            
            <el-form-item prop="email">
              <el-input
                v-model="registerForm.email"
                placeholder="邮箱"
                prefix-icon="el-icon-message"
              ></el-input>
            </el-form-item>
            
            <el-form-item prop="password">
              <el-input
                v-model="registerForm.password"
                type="password"
                placeholder="密码"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>
            
            <el-form-item prop="password_confirmation">
              <el-input
                v-model="registerForm.password_confirmation"
                type="password"
                placeholder="确认密码"
                prefix-icon="el-icon-lock"
                @keyup.enter.native="handleRegister"
              ></el-input>
            </el-form-item>
            
            <el-form-item>
              <el-button
                type="primary"
                :loading="loading"
                @click="handleRegister"
                style="width: 100%"
              >
                注册
              </el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'UserLogin',
  data() {
    return {
      activeTab: 'login',
      loading: false,
      loginForm: {
        email: '',
        password: ''
      },
      registerForm: {
        name: '',
        email: '',
        password: '',
        password_confirmation: ''
      },
      loginRules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ]
      },
      registerRules: {
        name: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        password_confirmation: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: this.validatePasswordConfirm, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    validatePasswordConfirm(rule, value, callback) {
      if (value !== this.registerForm.password) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          try {
            // 使用 Vuex store 的 login action
            await this.$store.dispatch('login', this.loginForm);
            
            this.$message({
              message: '登录成功！',
              type: 'success',
              duration: 2000
            });
            this.$router.push('/projects');
          } catch (error) {
            console.error('登录错误:', error);
            console.error('错误详情:', error.response);
            
            // 检查是否是 HTML 响应（通常意味着路由配置错误）
            const contentType = error.response?.headers['content-type'];
            if (contentType && contentType.includes('text/html')) {
              this.$message({
                message: 'API 路由配置错误：服务器返回了 HTML 而不是 JSON 数据，请检查 .htaccess 或 Nginx 配置',
                type: 'error',
                duration: 8000,
                showClose: true
              });
              return;
            }
            
            // 显示具体错误信息
            let errorMsg = '登录失败';
            if (error.response) {
              // 服务器返回了错误响应
              errorMsg = error.response.data?.error || error.response.data?.message || `服务器错误 (${error.response.status})`;
            } else if (error.request) {
              // 请求已发送但没有收到响应
              errorMsg = '无法连接到服务器，请检查网络连接';
            } else {
              // 请求配置出错
              errorMsg = error.message || '请求失败';
            }
            
            this.$message({
              message: errorMsg,
              type: 'error',
              duration: 5000,
              showClose: true
            });
          } finally {
            this.loading = false;
          }
        }
      });
    },
    handleRegister() {
      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          try {
            // 使用 Vuex store 的 register action
            await this.$store.dispatch('register', this.registerForm);
            
            this.$message({
              message: '注册成功！',
              type: 'success',
              duration: 2000
            });
            this.$router.push('/projects');
          } catch (error) {
            console.error('注册错误:', error);
            
            // 检查是否是 HTML 响应（通常意味着路由配置错误）
            const contentType = error.response?.headers['content-type'];
            if (contentType && contentType.includes('text/html')) {
              this.$message({
                message: 'API 路由配置错误：服务器返回了 HTML 而不是 JSON 数据，请检查 .htaccess 或 Nginx 配置',
                type: 'error',
                duration: 8000,
                showClose: true
              });
              return;
            }
            
            const errorMsg = error.response?.data?.error || error.response?.data?.message || '注册失败，请稍后重试';
            this.$message({
              message: errorMsg,
              type: 'error',
              duration: 5000,
              showClose: true
            });
          } finally {
            this.loading = false;
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-card {
  width: 400px;
}

.card-header {
  text-align: center;
}

.card-header h2 {
  margin: 0;
  color: #409EFF;
}
</style>
